import axios from 'axios'
import { toast } from 'react-toastify'
import intl from 'react-intl-universal'
import { select, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { RECEIPTS_API } from 'constants/url'
import { fromIdentity } from 'store/selectors'
import * as actions from './actions'

export function* getReceiptList({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.post, `${RECEIPTS_API}/receipts/search`, payload, {
      headers: {
        authenticateit_identity_ticket: ticket,
        'Content-Type': 'application/json'
      }
    })
    const { total, receipts } = data
    yield put(actions.getReceiptListSuccess({ total, receipts }))
  } catch (error) {
    yield put(actions.getReceiptListFail(error))
  }
}

export function* postResolveReceiptCase({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const response = yield call(
      axios.post,
      `${RECEIPTS_API}/cases/${payload.id}/accept`,
      { ...payload.data },
      {
        headers: {
          authenticateit_identity_ticket: ticket,
          'Content-Type': 'application/json'
        }
      }
    )
    if (response) {
      toast.success(intl.get('alerts.acceptCaseSuccess'))
      payload.router.push('/admin/receipts/tickets')
      yield put(actions.setReceiptCaseResolvedSuccess())
    }
  } catch (error) {
    const message = error?.response?.data?.error || error?.message
    toast.error(message)
    yield put(actions.setReceiptCaseResolvedFail(message))
  }
}

export function* postRejectReceiptCase({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const response = yield call(
      axios.post,
      `${RECEIPTS_API}/cases/${payload.id}/reject`,
      { ...payload.data },
      {
        headers: {
          authenticateit_identity_ticket: ticket,
          'Content-Type': 'application/json'
        }
      }
    )
    if (response) {
      toast.success(intl.get('alerts.rejectCaseSuccess'))
      payload.router.push('/admin/receipts/tickets')
      yield put(actions.setReceiptCaseRejectedSuccess())
    }
  } catch (error) {
    const message = error?.response?.data?.error || error?.message
    toast.error(message)
    yield put(actions.setReceiptCaseRejectedFail(error))
  }
}

export function* postSubmitMapping({ payload }) {
  const { callback, id, data } = payload
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const headers = {
      headers: {
        authenticateit_identity_ticket: ticket,
        'Content-Type': 'application/json'
      }
    }

    const { data: templateData } = yield call(
      axios.post,
      `${RECEIPTS_API}/retailer-mappings/templates`,
      { ...data },
      headers
    )

    const response = yield call(
      axios.post,
      `${RECEIPTS_API}/retailer-mappings/cases/${id}/bind-template`,
      { template_id: templateData.id },
      headers
    )

    if (response) {
      toast.success(intl.get('alerts.acceptCaseSuccess'))
      if (callback) callback()
      yield put(actions.setReceiptCaseResolvedSuccess())
    }
  } catch (error) {
    const message = error?.response?.data?.error || error?.message
    toast.error(message)
    yield put(actions.setReceiptCaseResolvedFail(message))
  }
}

export function* postRejectMapping({ payload }) {
  const { callback, id, data } = payload
  try {
    const ticket = yield select(fromIdentity.getTicket)
    const response = yield call(
      axios.post,
      `${RECEIPTS_API}/retailer-mappings/cases/${id}/reject`,
      { ...data },
      {
        headers: {
          authenticateit_identity_ticket: ticket,
          'Content-Type': 'application/json'
        }
      }
    )
    if (response) {
      toast.success(intl.get('alerts.rejectCaseSuccess'))
      if (callback) callback()
      yield put(actions.setReceiptMappingRejectedSuccess())
    }
  } catch (error) {
    const message = error?.response?.data?.error || error?.message
    toast.error(message)
    yield put(actions.setReceiptMappingRejectedFail(error))
  }
}

export function* postReceiptMappingTemplate({ payload }) {
  const { callback, data, id } = payload

  try {
    const ticket = yield select(fromIdentity.getTicket)

    const method = id ? axios.put : axios.post
    const action = id ? 'edit' : 'create'
    const url = `${RECEIPTS_API}/retailer-mappings/templates${id ? `/${id}` : ''}`

    const response = yield call(
      method,
      url,
      { ...data },
      {
        headers: {
          authenticateit_identity_ticket: ticket,
          'Content-Type': 'application/json'
        }
      }
    )
    if (response) {
      toast.success(intl.get(`alerts.${action}MappingTemplateSuccess`))
      if (callback) callback()
      yield put(actions.setReceiptCaseResolvedSuccess())
    }
  } catch (error) {
    const message = error?.response?.data?.error || error?.message
    toast.error(message)
    yield put(actions.setReceiptCaseResolvedFail(message))
  }
}

export default function*() {
  yield takeLatest(actions.GET_RECEIPT_LIST, getReceiptList)
  yield takeEvery(actions.SET_RECEIPT_CASE_RESOLVED, postResolveReceiptCase)
  yield takeEvery(actions.SET_RECEIPT_CASE_REJECTED, postRejectReceiptCase)
  yield takeEvery(actions.SET_RECEIPT_MAPPING, postSubmitMapping)
  yield takeEvery(actions.SET_RECEIPT_MAPPING_REJECTED, postRejectMapping)
  yield takeEvery(actions.SET_RECEIPT_MAPPING_TEMPLATE, postReceiptMappingTemplate)
}
